import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";

import ApiHelper from "../../../Helpers/ApiHelper";
import Overlay from "../../SharedComponents/Overlay";
import WrapUpHeader from "./WrapUpHeader";
import ReportItemMapper from "./ReportItemMapper";
import InventoryPdfButton from "../../PdfDownloadButton/Components/InventoryPdfButton";
import { useDispatch, useSelector } from "react-redux";

import "../Styles/index.css";
import "../Styles/WrapUp.css";
import "animate.css";
import { UpdateAlertModalData } from "../../SharedComponents/GeneralModals/Store";

export default function InventoryWrapUp() {
  const user = useSelector((state) => state.auth.user);
  const { inventoryResultId } = useParams();
  const [appData, setAppData] = useState([]);
  const [resultData, setResultData] = useState(null);
  const [showOverlay, setShowOverlay] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (inventoryResultId) {
      ApiHelper.getAsync(
        "ticket/GetInventoryCalculation",
        { id: inventoryResultId },
        function (response) {
          if (response.data.statusCode) MapResponse(response.data.data);
          else
            dispatch(
              UpdateAlertModalData({
                isShown: false,
                header: "calculationError",
                text: response.data.message,
              })
            );
        },
        user.token
      );
    } else {
      setShowOverlay(false);
      alert("problem");
    }
  }, [inventoryResultId, user.token]);

  let MapResponse = (resultData) => {
    setResultData(resultData);
    const scheme = JSON.parse(resultData.wrapUpJson);
    const calculation = JSON.parse(resultData.calculationJson);
    const calculatedScopes = calculation?.calculatedScopes;

    scheme.forEach((reportItem) => {
      if (reportItem.htmlEl) return;
      else if (reportItem.componentName === "AnsweringTendencyEntity") {
        reportItem.consistencyScore = calculation?.consistencyScore?.score;
        reportItem.inventoryLeanNumbers = calculation?.inventoryLeanNumbers;
      } else if (reportItem.subScopeId)
        reportItem.score = calculatedScopes.find(
          (x) => x.isSub && x.scopeId === reportItem.subScopeId
        )?.calculatedScore;
      else if (reportItem.scopeId) {
        reportItem.score = calculatedScopes.find((x) => !x.isSub && x.scopeId === reportItem.scopeId)?.calculatedScore;
      }
    });

    setAppData({ scheme, resultData });
    setShowOverlay(false);
  };

  const CreateQrUrl = () => {
    return window.location.origin + "/#/iResult/" + inventoryResultId;
  };

  return (
    <Container className={"mt-3"}>
      {showOverlay && <Overlay text="Sonuçlar hazırlanıyor" />}
      <WrapUpHeader resultData={appData.resultData} CreateQrUrl={CreateQrUrl}>
        <InventoryPdfButton
          inventoryResultId={inventoryResultId}
          resultData={resultData}
          docTitle={resultData?.demography?.name + " " + resultData?.applicationName ?? "unknown_pdf_name"}
        />
      </WrapUpHeader>
      <ReportItemMapper calculatedScheme={appData.scheme} type={"inventory"} />
    </Container>
  );
}
